import { ReduxArrayStateHandler } from '../ReduxArrayStateHandler';

export const RejectedOfferStateHandler = new ReduxArrayStateHandler(
  'REJECTED_OFFERS',
  'rejectedOffers',
);
